import { useEffect, useState } from "react";
import api from "../api/client";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setLogs(r.data.logs)).catch(() => {}); }, []);

  return (
    <div>
      <h1 style={{ marginBottom: 8 }}>Audit log</h1>
      <p className="muted small" style={{ marginTop: 0, marginBottom: 24 }}>Every admin action, append-only.</p>

      <div className="list">
        {logs.map((l) => (
          <div key={l._id} style={{ padding: "12px 16px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <span className="mono" style={{ fontWeight: 700 }}>{l.action}</span>
              <span className="muted small">{new Date(l.createdAt).toLocaleString()}</span>
            </div>
            <div className="muted small">{l.email} · {l.ip} · target {l.target}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
